import React from 'react';

import ac from '@modules/access-control/access-control.service'
import store from '@store/store'

class PrivilegedContent extends React.Component {

  allowed(permissions) {

    // TODO: handle errors and edge cases

    if(!permissions) return true;

    permissions = typeof permissions === 'string' ? [permissions] : permissions;

    const currentUser = store.getState().auth.user;

    return permissions.reduce((allowed, permission) => {
      const [perm, resource] = permission.split(':');
      return allowed && ac.can(currentUser.role)[perm](resource).granted;
    }, true)

  }

  render() {
    const { children, permissions } = this.props;
    
    return this.allowed(permissions)
      ? children
      : '';

  }
}

export default PrivilegedContent


// WEBPACK FOOTER //
// ./src/components/PrivilegedContent/PrivilegedContent.jsx